module.exports = __webpack_public_path__ + "img/Greatdays.5ce72517.png";